function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9836 0 0 1.9836 .0077073 1.8218)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m31.275 11.745c-2.084-3.395-6.826-9.09-15.147-9.09s-13.062 5.695-15.147 9.09a6.6 6.6 0 0 0 0 6.937c2.084 3.395 6.826 9.09 15.147 9.09s13.062-5.7 15.147-9.09a6.6 6.6 0 0 0 0-6.937zm-2.291 5.53c-1.79 2.911-5.842 7.809-12.855 7.809s-11.065-4.9-12.855-7.809a3.921 3.921 0 0 1 0-4.123c1.79-2.911 5.842-7.809 12.855-7.809s11.065 4.893 12.855 7.809a3.921 3.921 0 0 1-1e-3 4.123z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(2.409,1.494)",
  d: "m13.719 7a6.719 6.719 0 1 0 6.719 6.719 6.719 6.719 0 0 0-6.719-6.719zm0 10.751a4.032 4.032 0 1 1 4.032-4.032 4.032 4.032 0 0 1-4.032 4.032z"
}));
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.342b1a14.svg";
export { ForwardRef as ReactComponent };